const PatternTokenizer = require("./patternTokenizer");
const commandKeys = require("../../command-keys");

class Keywords extends PatternTokenizer {
    constructor() {
        super("keyword", /^([a-zA-Z_$][a-zA-Z\d_$]*)$/i);
        this.keywords = commandKeys.map(commandKey => commandKey.toUpperCase());
    }

    getToken(text, currentPosition) {
        const [consumedChars, token] = super.getToken(text, currentPosition);
        if (consumedChars > 0 && this.keywords.includes(token.value?.toUpperCase())) {
            token.type = this.type;
            return [consumedChars, token];
        } else {
            return [0, null];
        }
    }

    parse(tokens, current) {

    }
}

module.exports = Keywords;